// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  padding: 1rem;
}

.iteration-list {
  max-height: 260px;
  overflow: auto;
}

.iteration-item {
  padding: 0.25rem 0;
}

.primary-text {
  margin-bottom: 0.75rem;
}

.controls {
  display: flex;
  align-items: center;
}

.formulation-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.65rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/iterations-dialog/iterations-dialog.component.scss"],"names":[],"mappings":"AAAA;EAAW,aAAA;AAEX;;AADA;EAAkB,iBAAA;EAAmB,cAAA;AAMrC;;AALA;EAAkB,kBAAA;AASlB;;AARA;EAAgB,sBAAA;AAYhB;;AAXA;EAAY,aAAA;EAAc,mBAAA;AAgB1B;;AAfA;EAAsB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAY,mBAAA;EAAoB,gBAAA;AAuB1F","sourcesContent":[".content { padding: 1rem; }\n.iteration-list { max-height: 260px; overflow: auto; }\n.iteration-item { padding: .25rem 0; }\n.primary-text { margin-bottom: .75rem; }\n.controls { display:flex; align-items:center; }\n.formulation-option { display: flex; align-items: center; gap: .5rem; margin-top: .65rem; font-weight: 600; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
